import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCompanyMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type UpdateCompanyMutationPage = { readonly __typename?: 'RootMutationType', readonly updateCompany: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly lastError?: string | null, readonly provider: Types.OauthProvider }> } };

export type DisconnectProviderMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  provider: Types.OauthProvider;
}>;


export type DisconnectProviderMutationPage = { readonly __typename?: 'RootMutationType', readonly disconnectProvider: boolean };

export type DeleteProviderTokenMutationVariables = Types.Exact<{
  provider: Types.OauthProvider;
  companyId: Types.Scalars['ID']['input'];
}>;


export type DeleteProviderTokenMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteProviderToken: boolean };


export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($id: ID!, $name: String!) {
  updateCompany(id: $id, name: $name) {
    id
    uuid
    name
    tokens {
      id
      lastError
      provider
    }
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutationPage, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutationPage, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutationPage, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutationPage>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutationPage, UpdateCompanyMutationVariables>;
export const DisconnectProviderDocument = gql`
    mutation DisconnectProvider($companyId: ID!, $provider: OauthProvider!) {
  disconnectProvider(companyId: $companyId, provider: $provider)
}
    `;
export type DisconnectProviderMutationFn = Apollo.MutationFunction<DisconnectProviderMutationPage, DisconnectProviderMutationVariables>;

/**
 * __useDisconnectProviderMutation__
 *
 * To run a mutation, you first call `useDisconnectProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectProviderMutation, { data, loading, error }] = useDisconnectProviderMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useDisconnectProviderMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectProviderMutationPage, DisconnectProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectProviderMutationPage, DisconnectProviderMutationVariables>(DisconnectProviderDocument, options);
      }
export type DisconnectProviderMutationHookResult = ReturnType<typeof useDisconnectProviderMutation>;
export type DisconnectProviderMutationResult = Apollo.MutationResult<DisconnectProviderMutationPage>;
export type DisconnectProviderMutationOptions = Apollo.BaseMutationOptions<DisconnectProviderMutationPage, DisconnectProviderMutationVariables>;
export const DeleteProviderTokenDocument = gql`
    mutation DeleteProviderToken($provider: OauthProvider!, $companyId: ID!) {
  deleteProviderToken(provider: $provider, companyId: $companyId)
}
    `;
export type DeleteProviderTokenMutationFn = Apollo.MutationFunction<DeleteProviderTokenMutationPage, DeleteProviderTokenMutationVariables>;

/**
 * __useDeleteProviderTokenMutation__
 *
 * To run a mutation, you first call `useDeleteProviderTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderTokenMutation, { data, loading, error }] = useDeleteProviderTokenMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteProviderTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderTokenMutationPage, DeleteProviderTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderTokenMutationPage, DeleteProviderTokenMutationVariables>(DeleteProviderTokenDocument, options);
      }
export type DeleteProviderTokenMutationHookResult = ReturnType<typeof useDeleteProviderTokenMutation>;
export type DeleteProviderTokenMutationResult = Apollo.MutationResult<DeleteProviderTokenMutationPage>;
export type DeleteProviderTokenMutationOptions = Apollo.BaseMutationOptions<DeleteProviderTokenMutationPage, DeleteProviderTokenMutationVariables>;